<template>
  <q-page padding>
    <PageHeader
      title="Minhas Respostas"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <q-card class="q-mt-md" v-for="(dados, index) in data" :key="index">
      <q-card-section class="row align">
        <q-icon name="event" size="md" class="q-ml-lg" />
        <span class="text-h6 q-ml-lg">
          {{
            dados[0].dataHora.split(" ")[0].split("-")[2] +
            " " +
            "de" +
            " " +
            mes +
            " " +
            dados[0].dataHora.split(" ")[0].split("-")[0]
          }}
        </span>
      </q-card-section>
      <q-separator />
      <q-card-section
        class="responsive row justify-between"
        v-for="(dadosInternos, index) in dados"
        :key="index"
      >
        <div
          style="width: 17%"
          class="row align"
          v-if="dadosInternos.resposta === 1"
        >
          <q-icon
            class="q-ml-md"
            name="sentiment_very_dissatisfied"
            size="xl"
            color="red"
          />
          <span class="text-h6 q-mt-sm q-ml-lg">Péssimo</span>
        </div>

        <div
          style="width: 17%"
          class="row align"
          v-if="dadosInternos.resposta === 2"
        >
          <q-icon
            class="q-ml-md"
            name="sentiment_dissatisfied"
            size="xl"
            color="orange"
          />
          <span class="text-h6 q-mt-sm q-ml-lg">Ruim</span>
        </div>
        <div
          style="width: 17%"
          class="row align"
          v-if="dadosInternos.resposta === 3"
        >
          <q-icon
            class="q-ml-md"
            name="sentiment_neutral"
            size="xl"
            color="yellow-5"
          />
          <span class="text-h6 q-mt-sm q-ml-lg">Regular</span>
        </div>
        <div
          style="width: 17%"
          class="row align"
          v-if="dadosInternos.resposta === 4"
        >
          <q-icon
            class="q-ml-md"
            name="sentiment_satisfied"
            size="xl"
            color="blue"
          />
          <span class="text-h6 q-mt-sm q-ml-lg">Bem</span>
        </div>
        <div
          style="width: 17%"
          class="row align"
          v-if="dadosInternos.resposta === 5"
        >
          <q-icon
            class="q-ml-md"
            name="sentiment_very_satisfied"
            size="xl"
            color="green"
          />
          <span class="text-h6 q-mt-sm q-ml-lg">Ótimo</span>
        </div>
        <div style="width: 30%" class="row justify-center align">
          <q-icon name="schedule" size="xl" />
          <span class="text-h6 q-mt-sm q-ml-lg">
            {{
              dadosInternos.dataHora.split(" ")[1].split(":")[0] +
              ":" +
              dadosInternos.dataHora.split(" ")[1].split(":")[1]
            }}
          </span>
        </div>
        <div style="width: 17%" class="row">
          <span class="text-h6 q-mt-sm q-ml-lg">
            {{ dadosInternos.equipamento }}
          </span>
        </div>
        <div class="row align">
          <q-btn
            color="primary"
            class="button"
            size="sm"
            round
            icon="more_horiz"
            @click="justificativaInterno(dadosInternos.justificativa)"
          />
        </div>
      </q-card-section>
    </q-card>
    <q-dialog v-model="coletar">
      <q-card class="column" style="width: 800px; max-width: 80vw">
        <q-card-section class="row">
          <p class="text-h5">Justificativa</p>
        </q-card-section>
        <q-card-section class="row justify-center">
          <p class="text-h4" v-if="justificativa == ''">
            Nenhuma justificativa foi inserida
          </p>
          <q-input
            v-if="justificativa != ''"
            class="col-xs-11"
            v-model="justificativa"
            dense
            filled
            type="textarea"
            :disable="true"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { useStore } from "vuex";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    PageHeader,
  },
  setup() {
    const store = useStore();
    const data = ref("");
    const mes = ref("");
    const coletar = ref(false);
    const justificativa = ref("");

    const getHistorico = async () => {
      let resposta = await store.dispatch("cse/getHistorico");
      let teste = resposta.data.resultado.dados.reduce((anterior, atual) => {
        anterior[atual.dataHora.split(" ")[0]] = [
          ...(anterior[atual.dataHora.split(" ")[0]] || []),
          atual,
        ];
        return anterior;
      }, {});

      data.value = teste;

      let meses = [
        "janeiro",
        "fevereiro",
        "março",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro",
      ];
      let data2 = new Date();
      mes.value = meses[data2.getMonth()];
    };

    const justificativaInterno = async (value) => {
      coletar.value = true;

      justificativa.value = value;
    };

    onMounted(getHistorico);

    return {
      getHistorico,
      data,
      mes,
      coletar,
      justificativaInterno,
      justificativa,
    };
  },
};
</script>

<style scoped>
p {
  margin: 0;
}

.button {
  width: 50px !important;
  height: 50px !important;
}

.align {
  align-items: center;
}

@media only screen and (max-width: 919px) {
  .responsive div {
    width: inherit !important;
  }
}

@media only screen and (max-width: 500px) {
  .responsive span {
    font-size: 12px !important;
  }

  .button {
    width: 30px !important;
    height: 30px !important;
    margin-top: 10px;
  }

  .responsive i {
    font-size: 35px !important;
  }
}
</style>
